export const media = {
  folders: {
    destinations: "Destinations",
    trips: "Trips",
    activities: "Inspirations",
    guides: "Guides",
    blog: "Blog",
    teams: "Teams",
    general: "General",
    departurePhotos: "Departure photos",
  },
  page: {
    title: "Media library",
    subtitle: "Manage all images",
    findDuplicates: "Find duplicates",
    trashEmpty: "Trash is empty",
    noMedia: "No media",
    emptyFiltered: "No photo matches the filters",
    clearFilters: "Clear filters",
    loadErrorShort: "Could not load media.",
    total_one: "{{formatted}} photo",
    total_few: "{{formatted}} photos",
    total_other: "{{formatted}} photos",
    selectLoaded: "Select all loaded",
    select: "Select {{name}}",
    starred: "Good photo",
    usageCount_one: "Used: {{count}}",
    usageCount_few: "Used: {{count}}",
    usageCount_other: "Used: {{count}}",
    liveTwin: "Live photo",
    liveTwinTitle: "The library has a live photo with the same content",
  },
  filters: {
    label: "Filters",
    search: "Search alt, tags, filename, title…",
    countryNone: "No country",
    countryClear: "All countries",
    starred: "★ Good photos",
    sourceAll: "All sources",
    orientationAll: "All orientations",
    orientationLandscape: "Landscape",
    orientationPortrait: "Portrait",
    orientationSquare: "Square",
    usageAll: "All",
    usageUsed: "Used",
    usageUnused: "Unused",
    folderAll: "All types",
    trash: "Trash",
  },
  actions: {
    restore: "Restore",
    hardDelete: "Hard delete",
  },
  albums: {
    title: "Albums",
    allImages: "All images",
    newAlbum: "New album",
    newSubAlbum: "New sub-album",
    rename: "Rename",
    deleteAlbum: "Delete album",
    confirmDelete: "Delete album “{{name}}”? Images are not deleted.",
    expand: "Expand",
    collapse: "Collapse",
    addToAlbum: "Add to album",
    addToAlbumMenu: "Add to album…",
    addCountTitle_one: "Add {{count}} image to album",
    addCountTitle_few: "Add {{count}} images to album",
    addCountTitle_other: "Add {{count}} images to album",
  },
  move: {
    title_one: "Move {{count}} item",
    title_few: "Move {{count}} items",
    title_other: "Move {{count}} items",
    action: "Move",
  },
  merge: {
    title: "Merge duplicate images",
    apply_one: "Merge {{count}} duplicate",
    apply_few: "Merge {{count}} duplicates",
    apply_other: "Merge {{count}} duplicates",
    noneFound:
      "No exact duplicates found. (Duplicates are detected by SHA-256 content hash — run the content backfill first if hashes are missing.)",
    foundGroups_one: "Found {{count}} duplicate group",
    foundGroups_few: "Found {{count}} duplicate groups",
    foundGroups_other: "Found {{count}} duplicate groups",
    willDelete_one: "{{count}} image will be soft-deleted",
    willDelete_few: "{{count}} images will be soft-deleted",
    willDelete_other: "{{count}} images will be soft-deleted",
    willRepoint_one: "{{count}} reference repointed to the canonical image",
    willRepoint_few: "{{count}} references repointed to the canonical image",
    willRepoint_other: "{{count}} references repointed to the canonical image",
    keep: "Keep: {{name}}",
    removing_one: "Removing {{count}} duplicate: {{ids}}",
    removing_few: "Removing {{count}} duplicates: {{ids}}",
    removing_other: "Removing {{count}} duplicates: {{ids}}",
    progress_one: "Merged {{done}} of {{count}} group",
    progress_few: "Merged {{done}} of {{count}} groups",
    progress_other: "Merged {{done}} of {{count}} groups",
    finished: "Done. The library list refreshes when you close this dialog.",
    failed_one:
      "Merging stopped after {{done}} of {{count}} group. No further batches were sent; merged groups stay merged.",
    failed_few:
      "Merging stopped after {{done}} of {{count}} groups. No further batches were sent; merged groups stay merged.",
    failed_other:
      "Merging stopped after {{done}} of {{count}} groups. No further batches were sent; merged groups stay merged.",
    previewFailed: "Could not load the duplicate preview.",
  },
  focal: {
    dragHint: "Drag to set the focal point. X {{x}}, Y {{y}}",
    resetAuto: "Back to automatic",
  },
  // Focal point state in the media drawer (auto = centre, ai = main subject by AI, manual).
  focalState: {
    auto: "Automatic",
    ai: "AI",
    manual: "Manual",
  },
  // Previews of the web surfaces the photo is cropped on (order = FOCAL_SURFACE_IDS).
  focalPreviews: {
    title: "Surface previews",
    sampleHeading: "Heading over the photo",
    heroMobile: "Hero mobile",
    heroDesktop: "Hero desktop",
    card16x10: "Card 16:10",
    card3x4: "Card 3:4",
    square: "Square",
  },
  drawer: {
    title: "Media details",
    altLabel: "Alt text (required)",
    altPlaceholder: "Describe the image for SEO + accessibility",
    altRequired: "Alt text is required.",
    titlePlaceholder: "Optional title",
    descriptionPlaceholder: "Longer description — improves keyword search",
    tags: "Tags",
    tagPlaceholder: "Add tag and press Enter",
    focalPoint: "Focal point",
    publicUrl: "Public URL",
    copyUrl: "Copy URL",
    dimensions: "Dimensions",
    size: "Size",
    format: "Format",
    uploaded: "Uploaded",
    uploadedBy: "Uploaded by",
    usedIn: "Used in",
    notReferenced: "Not referenced by any entity.",
    inAlbums: "In albums",
    notInAlbum: "Not in any album.",
    removeFromAlbum: "Remove from {{name}}",
    exactDuplicates: "Exact duplicates",
    original: "Original",
    confirmTrash: "Move this image to trash?",
    confirmHardDelete: "Permanently delete this image? This cannot be undone.",
  },
  editor: {
    bold: "Bold (Ctrl+B)",
    italic: "Italic (Ctrl+I)",
    strikethrough: "Strikethrough",
    heading1: "Heading 1",
    heading2: "Heading 2",
    bulletList: "Bullet list",
    numberedList: "Numbered list",
    quote: "Quote",
    codeBlock: "Code block",
    moment: "Go2 Moment",
    insertImage: "Insert image",
    insertYoutube: "Insert YouTube video",
    horizontalRule: "Horizontal rule",
    undo: "Undo (Ctrl+Z)",
    redo: "Redo (Ctrl+Y)",
    startTyping: "Start typing…",
    linkUrlPrompt: "Link URL:",
    momentSelectFirst: "Select text first to mark it as a Go2 Moment.",
    momentPrompt: "Go2 Moment — description:",
    momentPromptExisting: "Go2 Moment — description (empty to remove):",
    youtubeVideo: "YouTube video",
    videoThumbAlt: "Video thumbnail",
    noUrlSet: "No URL set",
    youtubeUrlPrompt: "YouTube URL:",
    youtubeUrlPromptExample: "YouTube URL (e.g. https://www.youtube.com/watch?v=...):",
    changeUrl: "Change URL",
    setUrl: "Set URL",
    openVideo: "Open video",
    imageNotFound: "Image not found",
  },
};
